export default "__VITE_ASSET__428ab9e3__$_?component__"